import Vue from 'vue'
import ElementUI from 'element-ui'
import ptBr from 'element-ui/lib/locale/lang/pt-br'

let locale = ptBr
// http://element.eleme.io
Vue.use(ElementUI, { locale })

export default ElementUI
